module.exports = __webpack_public_path__ + "bin/672b2ba8682001320580c8d42db5ea2b.jpg";